import { RoomModel } from "@app/catalog";

export class RoomNotFoundMessage {
    public room: RoomModel;
    
    constructor(room: RoomModel)
    {
        this.room = room;
    }
}